// Medya Ekranı › Medya Yönetimi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'devices.media';

export const mediaManagementGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  // Gerçek ekranda ayarlar solda, medya listesi sağda
  mirror: true,
  title: t(`${G}.title`, 'Medya ekranına içerik nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Başlıkta adı ve kodu yazan medya ekranında (TV) dönecek resim ve videoları seçer, sırasını ve süresini ayarlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık, ekran adı ve kodu'),
    form: t(`${G}.regions.form`, 'Medya ekle ve ayarlar'),
    list: t(`${G}.regions.list`, 'Medya listesi'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Medya ekleyin'),
      text: t(`${G}.s1.text`, '"Resim Kütüphanesinden Seç" düğmesi resim kütüphanenizi açar. Ekranda göstermek istediğiniz resim ve videoları seçin; seçilenler sağdaki listenin sonuna eklenir. Listede zaten olan bir dosya ikinci kez eklenmez.'),
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Geçiş ve varsayılan süre'),
      text: t(`${G}.s2.text`, '"Geçiş Animasyonu" bölümünde bir içerikten diğerine geçişin biçimini (Fade, Slide, Zoom veya Yok) ve "Geçiş Süresi"ni seçin. "Varsayılan Resim Süresi", bundan sonra eklediğiniz resimlerin ekranda kaç saniye kalacağını belirler.'),
      tips: [
        t(`${G}.s2.tip1`, 'Varsayılan süreyi değiştirmek listede zaten olan resimlerin süresini değiştirmez.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Sırayı ve süreyi düzenleyin'),
      text: t(`${G}.s3.text`, 'İçerikler listedeki "Sıra" numarasına göre gösterilir. Yukarı / aşağı ok düğmeleriyle sırayı değiştirin, çöp kutusu ile içeriği listeden çıkarın. Her resmin "Gösterim Süresi"ni kaydırıcıyla 1–60 saniye arasında ayrı ayrı ayarlayabilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Videolarda süre ayarı yoktur.'),
        t(`${G}.s3.tip2`, 'Listeden çıkarmak dosyayı resim kütüphanesinden silmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, '"Kaydet" listeyi ve ayarları bu ekrana kaydeder ve medya ekranına içeriğin güncellendiğini bildirir. Değişiklikler "Kaydet"e basana kadar ekrana gitmez.'),
    },
  ],
});
